
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '@/hooks/useSubscription';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Use consolidated subscription hook
  const { subscription, loading: subscriptionLoading } = useSubscription();

  if (loading || subscriptionLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // IMPL-1 & IMPL-2: Check if user needs trial activation
  // If no subscription record exists, redirect to welcome video for trial activation
  if (!subscription && location.pathname !== '/welcome-video') {
    return <Navigate to="/welcome-video" replace />;
  }

  // If user has expired trial or no active subscription, allow access but force trial flow in UI
  // The UI components will handle showing the PricingModal automatically

  return <>{children}</>;
};

export default ProtectedRoute;
